import React from 'react';
import PropTypes from 'prop-types';

import { INPUT_COLORS } from '@wds/helpers';
import useStyles from './useStyles';

const InputErrorMessage = ({ errorMessage, color }) => {
  const { wrenchInputErrorMessage } = useStyles({ color });
  if (!errorMessage && !color) return null;
  if (errorMessage && color !== 'warning') {
    throw new Error(
      'Having an errorMessage and a success theme is not allowed'
    );
  }

  return (
    <div role="alert" className={wrenchInputErrorMessage}>
      {errorMessage}
    </div>
  );
};

InputErrorMessage.propTypes = {
  /**
   * Color Variant
   */
  color: PropTypes.oneOf(INPUT_COLORS),
  /**
   * Error message for input validation
   */
  errorMessage: PropTypes.node,
};

InputErrorMessage.defaultProps = {
  color: undefined,
  errorMessage: undefined,
};

export default InputErrorMessage;
